import {
    Stack,
    Typography,
    FormControlLabel,
    Switch,
    Button,
} from "@mui/material";

export default function OrderSettings() {
    return (
        <>
            <Typography
                sx={{
                    fontSize: 24,
                    fontWeight: 700,
                    mb: 0.5,
                }}
            >
                Order Settings
            </Typography>

            <Typography sx={{ color: "#777", mb: 4 }}>
                Configure order behavior
            </Typography>

            <Stack spacing={3}>
                <FormControlLabel
                    control={<Switch />}
                    label="Auto Complete Paid Orders"
                />

                <FormControlLabel
                    control={<Switch />}
                    label="Allow Negative Stock"
                />

                <FormControlLabel
                    control={<Switch />}
                    label="Low Stock Warning"
                />

                <Button
                    variant="contained"
                    sx={{
                        width: "fit-content",
                        backgroundColor: "#111",
                        borderRadius: 3,
                        textTransform: "none",
                    }}
                >
                    Save Changes
                </Button>
            </Stack>
        </>
    );
}